// extracted by mini-css-extract-plugin
export default {"affair":"Affair_affair__jhwIF","name":"Affair_name__2w9As","closeButton":"Affair_closeButton__kRBZJ"};